<!-- 指定签署位置 -->
<template>
    <div
        ref="Rect"
        class="appoint-location"
    >
        <template v-for="(rect, index) in rectangles">
            <div
                class="appoint-rect"
                v-show="pageNumber === rect.page"
                :class="{'has-bg': !rect.src, 'across-page': rect.rectType == 'ACROSS_PAGE', ...autoAddStamperClass(rect) }"
                :data-page="rect.page"
                :style="getRectangleStyle(rect)"
                @dragover.stop="handleDragover($event, rect)"
                @drop.stop="handleDrop(rect)"
                @click="handleDrop(rect)"
                :key="index"
            >
                <template v-if="rect.src && rect.rectType !== 'TIMESTAMP'">
                    <img
                        class="stamper-image"
                        :src="rect.src"
                        alt=""
                    >
                    <template v-if="showAutoAddStamper(rect)">
                        <div
                            class="auto-add-time-stamper"
                            :style="{
                                width: rect.autoAddTimeStamperPosition.timeStamperStyle.width,
                            }"
                        >
                            <img
                                :src="rect.autoAddTimeStamperPosition.src"
                            >
                        </div>
                    </template>

                    <i
                        class="delete-icon el-icon-circle-close-outline"
                        @click.stop="handleDelete(rect)"
                    ></i>
                </template>
                <template v-else-if="rect.src && rect.rectType === 'TIMESTAMP'">
                    <div
                        class="appoint-time-rect"
                        @click="handleClickStatus(rect)"
                        v-click-outside="(e) => handleClickOutside(e, rect)"
                    >
                        <div
                            v-if="blockToolTimeAuth(rect)"
                            :style="blockToolStyle()"
                        >
                            <block-tool-time :block="rect"/>
                        </div>
                        <img
                            :src="rect.src"
                            alt=""
                        >
                    </div>
                </template>
                <span v-else>{{rect.label}}</span>
            </div>
        </template>
    </div>
</template>

<script>
import qs from 'qs';
import blockToolTime from './block-tool-time.vue';
import ToolBarStyle from '../utils/block-style';

const wrapperClassName = 'pdf-scroll-page';

export default {
    name: 'AppointRectangle',
    components: { blockToolTime },
    data () {
        return {};
    },
    props: {
        rectangles: Array,
        sealUrl: String,
        datePattern: String,
        sealId: String,
        verify: Boolean,
        isEtlType: Boolean,
        isPersonal: Boolean,
        isPDF: Boolean,
        isZWFWSEAL: Boolean,
        pageNumber: Number,
        leftControl: {
            type: Boolean,
            default: true,
        },
        page: {
            type: Object,
            default () {
                return {}
            }
        },
        originPointer: {
            type: String,
            default: 'LB'
        },
    },
    inject: ['signPage'],
    computed: {
        isOriginLB() {
            return this.originPointer === 'LB';
        },
        autoAddStamperClass() {
            return (rect) => {
                if (rect.autoAddTimeStamperPosition) {
                    const { position } = rect.autoAddTimeStamperPosition;
                    const className = `auto-add-time-stamper-rect__${position}`;
                    return {
                        'auto-add-time-stamper-rect': true,
                        [className]: true
                    }
                };
                return {};
            }
        },
        showAutoAddStamper() {
            return (rect) => {
                return !!rect.autoAddTimeStamperPosition;
            }
        },
        getRectangleStyle() {
            return (rect) => {
                if (rect.autoAddTimeStamperPosition) {
                    return {
                        ...rect.style,
                        ...rect.autoAddTimeStamperPosition.additionStyle ?? {},
                    }
                }
                return rect.style;
            }
        },
        autoAddTimeStamperClass() {
            if (!this.isAutoAddTimeStamper) {
                return '';
            }

            const className = {
                'bottom': 'auto-add-timestamp__bottom',
                'right': 'auto-add-timestamp__right',
                'left': 'auto-add-timestamp__left',
            }

            return `auto-add-timestamp ${className[this.stamper.autoAddTimeStamperPosition.position]}`;
        },
    },
    methods: {
        handleDragover (e) {
            e.preventDefault();
        },
        //工具栏样式
        blockToolStyle () {
            return new ToolBarStyle();
        },
        blockToolTimeAuth(rectangle) {
            return rectangle.isClicked && !rectangle['isAppointTimestampFormatType'];
        },
        // 时间戳图片
        getTimeStampImage (formatType = 'SECONDARY_THIRD') {
            const param = { formatType, zwdt_access_token: this.zwdt_access_token || this.$route.query.zwdt_access_token };
            return `${this.BASE_APP_PATH}/seal/timestamp?${qs.stringify(param)}`;
        },
        handleDrop (rect) {
            if (rect.rectType === 'TIMESTAMP') {
                return;
            }
            if ((this.verify || this.isPersonal) && this.sealUrl) {
                if (!this.isPDF && !this.isZWFWSEAL) {
                    this.$message.error("请使用有效的国办印章");
                    return;
                }

                // 执行自动带出时间戳
                this.$set(rect, 'src', this.sealUrl);
                this.$set(rect, 'sealId', this.sealId);
                if (this.signPage?.contract?.signWithTime && !rect.rectType.includes('ACROSS_PAGE')) {
                    this.handleAutoAddStamper(rect);
                }
            } else {
                this.$message.error('当前没有可使用的印章！');
            }
        },
        handleAutoAddStamper (rect) {
            const dimension = this.page;
            // 默认时间戳在A4纸下的尺寸
            const TIME_SPEC_WIDTH = 27.7;
            const TIME_SPEC_HEIGHT = 7.4;

            const wrapper =  this.Utils.getParentByClass(this.$refs.Rect, wrapperClassName);
            const documentWidth = wrapper && wrapper.offsetWidth;
            const documentHeight = wrapper && wrapper.offsetHeight;

            const timeStamperHeight = TIME_SPEC_HEIGHT / dimension.height;
            const timeStamperWidth = TIME_SPEC_WIDTH / dimension.width;

            const { offsetX, offsetY, width, height } = rect;
            let autoAddTimeStamp = {
                bottom: true,
                right: true,
                left: true,
            }

            if (offsetY - timeStamperHeight < 0) {
                // console.log('下侧溢出')
                autoAddTimeStamp.bottom = false;
            }


            if (offsetX + timeStamperWidth + width > 1) {
                // console.log('右侧溢出')
                autoAddTimeStamp.right = false;
            }

            if (offsetX - timeStamperWidth < 0) {
                // console.log('左侧溢出')
                autoAddTimeStamp.left = false;
            }

            let firstTrueKey = Object.keys(autoAddTimeStamp).find(key => autoAddTimeStamp[key]);

            if (firstTrueKey) {
                // px高度
                const timestampPixelWidth = timeStamperWidth * 100 * (documentWidth / 100);
                const timestampPixelHeight = timeStamperHeight * 100 * (documentHeight / 100);

                switch (firstTrueKey) {
                    case 'bottom': {
                        this.$set(rect, 'autoAddTimeStamperPosition', {
                            position: 'bottom',
                            src: this.getTimeStampImage('CHINESE_Y_M_D'),
                            additionStyle: {
                                height: ((height + timeStamperHeight) * 100) + '%',
                                bottom: this.isOriginLB ? ((offsetY + timeStamperHeight) * 100 + '%') : ((1 - rectangle.offsetY - timeStamperHeight) * 100 + '%'),
                            },
                            timeStamperStyle: {
                                width: timestampPixelWidth + 'px',
                                height: timestampPixelHeight + 'px',
                            },
                        });
                        break;
                    }
                    case 'right': {
                        this.$set(rect, 'autoAddTimeStamperPosition', {
                            position: 'right',
                            src: this.getTimeStampImage('CHINESE_Y_M_D'),
                            additionStyle: {
                                width: ((width + timeStamperWidth) * 100) + '%',
                            },
                            timeStamperStyle: {
                                width: timestampPixelWidth + 'px',
                                height: timestampPixelHeight + 'px',
                            }
                        });
                        break;
                    }
                    case 'left': {
                        this.$set(rect, 'autoAddTimeStamperPosition', {
                            position: 'left',
                            src: this.getTimeStampImage('CHINESE_Y_M_D'),
                            additionStyle: {
                                width: ((width + timeStamperWidth) * 100) + '%',
                                left: (offsetX - timeStamperWidth) * 100 + '%'
                            },
                            timeStamperStyle: {
                                width: timestampPixelWidth + 'px',
                                height: timestampPixelHeight + 'px',
                            }
                        });
                        break;
                    }
                }
            }
        },
        handleClickStatus (rect) {
            this.$emit('resetStamperAndRectangles');
            this.$set(rect, 'isClicked', true);
        },
        handleClickOutside(e, rect) {
            this.$set(rect, 'isClicked', false);
        },
        handleDelete (rect) {
            this.$set(rect, 'src', '');
            this.$set(rect, 'sealId', '');
            if (rect.hasOwnProperty('autoAddTimeStamperPosition')) {
                this.$delete(rect, 'autoAddTimeStamperPosition');
            }
        }
    }
};
</script>

<style lang="less" scoped>
.appoint-location {
    .appoint-rect {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border: 2px dashed #2489F2;
        font-size: 14px;
        cursor: pointer;

        &.has-bg {
            background: rgba(197, 0, 1, 0.1);
        }
        img {
            width: 100%;
        }
        .appoint-time-rect {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .auto-add-time-stamper-rect {
        .stamper-image {
            flex: 1;
        }
        .auto-add-time-stamper {
            margin: 5px 0;
        }
    }

    .auto-add-time-stamper-rect__left {
        flex-direction: row-reverse;
        align-items: flex-end;
        .auto-add-time-stamper {
            margin: 0;
        }
    }

    .auto-add-time-stamper-rect__right {
        align-items: flex-end;
        .auto-add-time-stamper {
            margin: 0;
        }
    }

    .auto-add-time-stamper-rect__bottom {
        flex-direction: column;
    }

    .delete-icon {
        position: absolute;
        top: -8px;
        right: -8px;
        background: @white;
        z-index: 1000;
        cursor: pointer;
    }
}
</style>
